module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/CPU2-533448edae0170c56eee741da00d8789.svg";